import { Problem, ProblemDetectionContext, ProblemType, ProblemSeverity } from '../types';

export function detectLexErrors(context: ProblemDetectionContext, generateId: () => string): Problem[] {
  const problems: Problem[] = [];
  const { logs } = context;

  // Look for Lex-related errors
  const lexErrorLogs = logs.filter(
    (log) =>
      log.Source === 'Lex' &&
      (log.LogData.Content?.includes('error') ||
        log.LogData.Content?.includes('failed') ||
        (log.EventType === 'ExecutionResult' && log.LogData.Action?.ExecutionResult === 'Error'))
  );

  lexErrorLogs.forEach((errorLog) => {
    const originalIndex = logs.indexOf(errorLog);
    problems.push({
      id: generateId(),
      type: ProblemType.LEX_ERROR,
      severity: ProblemSeverity.HIGH,
      title: 'Lex Bot Error Detected',
      description: `Lex bot encountered an error: ${errorLog.LogData.Content || 'Unknown error'}`,
      timestamp: errorLog.AbsoluteTime,
      source: 'IVR_LOG',
      relatedData: { log: errorLog },
      suggestions: [
        'Check Lex bot configuration',
        'Review bot intents and utterances',
        'Verify bot permissions and integrations'
      ],
      index: originalIndex >= 0 ? originalIndex : undefined
    });
  });

  return problems;
}
